import { Link } from "react-router-dom";
import { classNamesOrEmpty } from "../../style/common";
import { CardVariant } from "../../models/CardVariant";
import { HTMLAttributeAnchorTarget } from "react";

export type CardVariantImageLinkOverlayProps = {
    variant: CardVariant,
    className?: string | undefined,
    target?: HTMLAttributeAnchorTarget
}

export function CardVariantImageLinkOverlay(props: CardVariantImageLinkOverlayProps) {
    return (
        <Link
            to={`/cards/${props.variant.serial}`}
            target={props.target}
            className={`z-[9] absolute top-0 bottom-0 left-0 right-0 cursor-pointer rounded-xl overflow-hidden outline-emphasis ${classNamesOrEmpty(props.className)}`}>
            <span className="sr-only">{`Link to ${props.variant.card.name ?? ""} ${props.variant.card.serial} details`}</span>
        </Link>
    )
}